import React from 'react'
import { IoLogInOutline } from "react-icons/io5";
import "./Button.scss";
import { NavLink } from 'react-router-dom'

function Button({
    text,
    button2ndDesign,
    button3rdDesign,
    buttonLink,
    scrollToId
}) {
    const className = button2ndDesign
        ? "ButtonContainer ButtonContainer2"
        : button3rdDesign
            ? "ButtonContainer ButtonContainer3"
            : "ButtonContainer";


    const handleScroll = () => {
        if (!scrollToId) return;

        const section = document.getElementById(scrollToId);
        if (!section) return;

        const yOffset = -120; // 👈 scroll 100px above the section
        const y =
            section.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({
            top: y,
            behavior: "smooth", // 👈 native smooth animation
        });
    };

    // 👉 If scrollToId exists, use button (no navigation)
    if (scrollToId) {
        return (
            <button className={className} onClick={handleScroll}>
                <IoLogInOutline className="loginIcon" />
                <div className="buttonText">{text}</div>
            </button>
        );
    }

    // 👉 Otherwise behave as normal NavLink
    return (
        <NavLink to={buttonLink} className={className}>
            <IoLogInOutline className="loginIcon" />
            <div className="buttonText">{text}</div>
        </NavLink>
    );
}

export default Button;
